import { Controller } from '@hotwired/stimulus';

// 支給日(paid_on)のインライン編集トグル。
// 「編集」で日付フォームを表示、「キャンセル」で表示へ戻す。
// 送信後の差し替えは Turbo Frame が担うため、ここは表示切り替えのみ。
export default class extends Controller {
  static targets = ['form', 'text'];

  edit(event) {
    const message = event.currentTarget.dataset.paidOnEditConfirmValue;
    if (message && !window.confirm(message)) { return; }

    if (this.hasTextTarget) { this.textTarget.classList.add('d-none'); }
    if (this.hasFormTarget) { this.formTarget.classList.remove('d-none'); }
  }

  cancel() {
    if (this.hasFormTarget) { this.formTarget.classList.add('d-none'); }
    if (this.hasTextTarget) { this.textTarget.classList.remove('d-none'); }
  }
}
